import styled, { css } from 'styled-components';
import { StyleButtonBase } from '../button-base';
import { Body2Styles } from '../typography';
import { getSizeBy, getColor, getColorShade, getHintColor } from '../../../src/styled/utils';
import { groupRadius, groupBorder } from '../../styled/utils';
export const Wrapper = styled.div `
  display: flex;
`;
export const IconWrapperCSS = css `
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;
export const IconAppendWrapper = styled.span `
  ${IconWrapperCSS};
  padding-right: ${getSizeBy(2)};

  svg > * {
    fill: ${({ $disabled }) => $disabled
    ? getColorShade('onSurface', 'lowEmphasis')
    : getColorShade('onSurface', 'mediumEmphasis')};
  }

  padding-right: ${({ $size }) => ($size === 'small' ? getSizeBy(2) : getSizeBy(3))};
`;
export const IconPrependWrapper = styled(IconAppendWrapper) `
  margin-right: ${getSizeBy(0)};
  padding-right: ${getSizeBy(1.5)};
  padding-left: ${getSizeBy(3)};

  svg > * {
    fill: ${({ $disabled }) => $disabled
    ? getColorShade('onSurface', 'lowEmphasis')
    : getColorShade('onSurface', 'mediumEmphasis')};
  }
`;
const sizeLiteralInputWrap = {
    small: 7,
    medium: 9,
    large: 11,
    extraLarge: 11 /*Extra large is deprecated*/
};
export const InputWrap = styled.div `
  display: flex;
  flex-direction: column;
  width: ${({ withSelect }) => (withSelect ? '70%' : '100%')};
  height: ${({ sizeComponent }) => getSizeBy(sizeLiteralInputWrap[sizeComponent])};
`;
const InputTextWrapHover = css `
  &:hover {
    border-color: ${getColorShade('onSurface', 'lowEmphasis')};
  }
`;
const InputTextWrapFocusWithin = css `
  &:focus-within {
    border-color: ${getColor('primary')};
  }
`;
export const InputTextWrap = styled.div `
  display: flex;
  height: 100%;
  background-color: ${({ disabled }) => disabled ? getColorShade('onSurface', 'hover') : getColor('surface')};
  border-color: ${({ $hintType, disabled }) => {
    if ($hintType)
        return getHintColor($hintType);
    if (disabled)
        return getColorShade('onSurface', 'default');
    return getColorShade('onSurface', 'outline');
}};
  border-style: solid;
  border-width: ${({ $groupPosition, $isTouched }) => $isTouched ? '1px' : groupBorder($groupPosition)};
  border-radius: ${({ $groupPosition }) => groupRadius($groupPosition)};

  ${({ disabled, $permanentHint }) => !disabled && !$permanentHint && InputTextWrapHover}
  ${({ $permanentHint }) => !$permanentHint && InputTextWrapFocusWithin}

  /* removes default arrows Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    margin: 0;
    -webkit-appearance: none; /* stylelint-disable-line */
  }

  /* removes default arrows Firefox */
  input[type='number'] {
    -moz-appearance: textfield; /* stylelint-disable-line */
  }
`;
export const Input = styled.input `
  position: relative;
  display: inline-block;
  width: 100%;
  height: 100%;
  max-height: 100%;
  margin-left: ${({ $bePrependIcon }) => ($bePrependIcon ? 0 : getSizeBy(3))};
  color: ${({ disabled, $hintType, $textType, $isTouched, $permanentHint }) => {
    if (!disabled) {
        if ($isTouched && !$permanentHint) {
            return getColor('onSurface');
        }
        if ($textType) {
            return getHintColor($textType);
        }
        if ($hintType) {
            return getHintColor($hintType);
        }
        return getColor('onSurface');
    }
    return getColorShade('onSurface', 'mediumEmphasis');
}};
  background: ${({ disabled }) => disabled ? getColorShade('onSurface', 'hover') : getColor('surface')};
  border: none;
  ${Body2Styles};

  &:focus {
    border: none;
    outline: none;
  }

  &:disabled {
    background: transparent;
  }

  &::placeholder {
    color: ${getColorShade('onSurface', 'lowEmphasis')};
  }

  border-radius: inherit;
`;
const sizeLiteralNumberButton = {
    small: 3.5,
    medium: 4.3,
    large: 5.5,
    extraLarge: 5.5 /* Size 'extraLarge' is deprecated, use large instead */
};
export const InputNumberButton = styled.button `
  ${StyleButtonBase};
  width: 100%;
  height: ${({ $size }) => getSizeBy(sizeLiteralNumberButton[$size])};
  color: ${getColorShade('onSurface', 'mediumEmphasis')};
  font-size: 18px;
  line-height: ${({ $size }) => getSizeBy(sizeLiteralNumberButton[$size])};
  text-align: center;
  background-color: initial;

  &:not(:disabled) {
    cursor: pointer;
  }

  &:disabled {
    pointer-events: none;
  }

  &:hover:not(:disabled) {
    background-color: ${getColorShade('primary', 'pressed')};
  }
`;
export const InputNumberButtonWrap = styled.span `
  display: flex;
  flex-direction: column;
  width: 24px;
  height: 100%;
  border-left: 1px solid ${getColorShade('onSurface', 'outline')};

  ${InputNumberButton}:first-child {
    border-bottom: 1px solid ${getColorShade('onSurface', 'outline')};
  }
`;
